/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Create_HintInputs */

const cs_signing_create_hint = /** @type {(inputs: Signing_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte připravené PDF v kategorii SMLOUVA, PRÁVNÍ, REZERVACE nebo FINANCOVÁNÍ.`)
};

const en_signing_create_hint = /** @type {(inputs: Signing_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a ready PDF in CONTRACT, LEGAL, RESERVATION, or FINANCING category.`)
};

/**
* | output |
* | --- |
* | "Pick a ready PDF in CONTRACT, LEGAL, RESERVATION, or FINANCING category." |
*
* @param {Signing_Create_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_create_hint = /** @type {((inputs?: Signing_Create_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Create_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_create_hint(inputs)
	return cs_signing_create_hint(inputs)
});